import { submitV2AnalyticsEvent } from "../analyticsUtils";

function dispatchViewProductDetails(templateContext) {
  const { productCode, productTitle: productName } = templateContext;

  submitV2AnalyticsEvent("viewProductDetails", {
    productCode,
    productName,
    origin: "PLP",
    originID: null,
    searchId: sessionStorage.getItem("searchId"),
    rank: sessionStorage.getItem("rank"),
    pageNumber: sessionStorage.getItem("pageNumber"),
    searchTerm: sessionStorage.getItem("searchTerm"),
  });
}

export default dispatchViewProductDetails;
